import {DefaultTheme as theme} from "../../../../../theme";
import {RoundedButton} from "../../../../../elements";
import {observer} from "mobx-react";
import {usePromptManagementStore} from "../../hooks";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import Icon from "../../../../../elements/icon/Icon";
import {ActionIconWrapper} from "./ActionsHeader.styled";

export const ActionsHeaderList = observer(() => {
  const navigate = useNavigate();

  const onHandleAddPrompt = useCallback(() => {
    navigate("/v2/prompt-management-system/create")
  }, []);

  return (
    <RoundedButton
      width="99px"
      height="40px"
      color={theme.colors.activeBlue}
      onClick={onHandleAddPrompt}
    >
      <ActionIconWrapper><Icon name="plus" width={"16px"} height={"16px"} /></ActionIconWrapper> New
    </RoundedButton>
  );
});
